module.exports = __webpack_public_path__ + "static/media/P2_S9_1.8eab06b0.png";